export default {
    color: '#fdcdc6',
    urls: ['/about-agency', '/expertise', '/start-up-smart-packages', '/product-testing-team']
}
